module.exports = __webpack_public_path__ + "img/lg_ring_g_c_1_1@2x.bd7f3bec.png";